// localStorage
const AUTHORIZATION_TOKEN = 'marketing-list-token';

const getAuthTokenFromStorage = () => localStorage.getItem(AUTHORIZATION_TOKEN);
const removeAuthTokenFromStorage = () => localStorage.removeItem(AUTHORIZATION_TOKEN);
const setAuthTokenToStorage = token => localStorage.setItem(AUTHORIZATION_TOKEN, token);

export {
  setAuthTokenToStorage,
  getAuthTokenFromStorage,
  removeAuthTokenFromStorage,
};
